export const namespaceWrapper = (prefix: string) => (payload: string) => `${prefix}/${payload}`
